


























import { urlHashes } from '@constants';
import { PageType } from '@enums';
import { UpdateProduct } from '@interfaces/common/UpdateProduct';
import { Image } from '@interfaces/hybris/Image';
import { Product } from '@interfaces/hybris/Product';
import { VariantOption } from '@interfaces/hybris/VariantOption';
import { updateProductMixin } from '@mixins';
import { setPathParam, updateProductMeta } from '@services/utils';
import { store } from '@store';
import { UpdateProductInstance } from '@types';
import { BTooltip as bTooltip } from 'bootstrap-vue/esm/components/tooltip/tooltip';
import Vue, { PropType, VueConstructor } from 'vue';
import { mapActions, mapState } from 'vuex';

export default (Vue as VueConstructor<Vue & UpdateProductInstance>).extend({
	name: 'Colors',
	components: {
		bTooltip,
	},
	mixins: [updateProductMixin],
	props: {
		productName: {
			type: String,
			default: '',
		},
		colors: {
			type: Array as PropType<VariantOption[]>,
			default: () => [],
		},
		large: {
			type: Boolean,
			default: false,
		},
		pageType: {
			type: Number,
			default: -1,
		},
		isAdditionalAccessories: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapState('pdp', ['product', 'productCode', 'additionalDevices', 'accessories']),
		...mapState('plp', ['productList']),
		...mapState('cart', ['cartAdditionalDevices', 'cartAccessories']),
		colorCode(): (color: VariantOption) => string {
			return color => color.variantMeasures?.[0]?.colorCode;
		},
		colorName(): (color: VariantOption) => string {
			return color => color.variantMeasures?.[0]?.value;
		},
		colorImage(): (color: VariantOption) => Image {
			return color => color.variantMeasures?.[0]?.image;
		},
		isDefaultColor(): any {
			return (color: VariantOption) => {
				switch (this.pageType) {
					case PageType.PDP: return this.productCode === color.code;
					default: return color.defaultVariant;
				}
			};
		},
		colorList(): VariantOption[] {
			return this.colors;
		},
	},
	methods: {
		...mapActions('pdp', ['getProductData']),
		...mapActions('cart', ['updateQuantity']),
		getBackgroundStyles(color: VariantOption): Partial<CSSStyleDeclaration> {
			return {
				backgroundColor: this.colorCode(color),
				backgroundImage: this.colorImage(color) ? `url(${this.colorImage(color)?.url})` : '',
				backgroundSize: 'contain',
			};
		},
		changeColor(color) {
			if (this.pageType === PageType.PLP || this.pageType === PageType.HEROES)
				return;

			if (this.pageType === PageType.PDP) {
				const newUrl = window.location.protocol + '//' + window.location.host + setPathParam(1, color.code) +
					`#${urlHashes.offerKey}=${this.offerType}`;

				window.history.pushState({ path: newUrl }, '', newUrl);
				store.dispatch('changeData', { store: 'pdp', varToChange: 'productCode', payload: color.code });
				store.dispatch('changeData', { store: 'pdp', varToChange: 'isReplaceState', payload: true });
				this.getProductData().then(() => updateProductMeta(this.product));
			}
			else {
				this.updateQuantity({ params: false });
				this.colorList.forEach((element: VariantOption) => (element.defaultVariant = element.code === color.code));

				if (this.pageType === PageType.PDP_ADDITIONAL_DEVICES)
					this.setNewData(color.code, this.additionalDevices?.products, PageType.PDP_ADDITIONAL_DEVICES, true);

				if (this.pageType === PageType.CART_ADDITIONAL_DEVICES) {
					if (this.isAdditionalAccessories) {
						this.setNewData(color.code, this.cartAccessories?.products, PageType.CART_ADDITIONAL_DEVICES);
						this.updateQuantity({ params: true });
					}

					else this.setNewData(color.code, this.cartAdditionalDevices?.products, PageType.CART_ADDITIONAL_DEVICES, true);
				}

				if (this.pageType === PageType.PLP_ACCESSORIES) {
					this.updateQuantity({ params: true });

					if (this.isAdditionalAccessories)
						this.setNewData(color.code, this.accessories);

					else this.setNewData(color.code, this.productList);
				}
			}
		},
		setNewData(colorCode: string, products: Product[], type = PageType.PLP_ACCESSORIES, isDevice = false): void {
			const updateData = isDevice ? this.updateProductData : this.updateAccessoryData;

			updateData(colorCode, products, type)
				.then((res: UpdateProduct) => {
					this.$set(products, res.productIndex, res.newProduct);
				});
		},
	},
});
